import React from 'react';
import PropTypes from 'prop-types';

export default class SubstancePubChemReferences extends React.PureComponent {

  render() {
    const { references } = this.props;

    return references ? (
      <React.Fragment>
        {Object.keys(references).map(title => (
          <a
            className='els-btn els-btn-sm els-btn-link blue els-btn-right'
            key={title}
            href={references[title]}
            target='_blank'>
            <span>{title}</span>
            <svg className='els-btn-icon'>
              <use xlinkHref='#icon-up-right' />
            </svg>
          </a>
        ))}
      </React.Fragment>
    ) : null;
  }
}

SubstancePubChemReferences.propTypes = {
  references: PropTypes.array.isRequired,
};
